// extracted by mini-css-extract-plugin
module.exports = {"form":"rdg_6f059839","rte":"rdg_23d6498a"};